(function () {
    'use strict';

    angular.module('app.dailyLogs', [
        'app.core',
        'app.widgets'
    ]);
})();
